import React from 'react'
import { useHistory } from 'react-router-dom'
import { Paper, Box, Button, Typography } from '@mui/material'
import HomeIcon from '@mui/icons-material/Home'
import { DataGrid, type GridColDef, type GridRenderCellParams } from '@mui/x-data-grid'
import ErrorComponent from '../../../components/ui-widgets/ErrorComponent'
import LoadingComponent from '../../../components/ui-widgets/LoadingComponent'

import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { formatDateStringAsApiFormat } from '../../../../utility/formatters/DateFormatter'
import { useCurrencyExchangeApiGetActivePairs } from '../../../../api-services/financial/currencyExchangeApi'

const CurrencyExchangePairsPage: React.FC = (props: any) => {
  const getActivePairsApiResult = useCurrencyExchangeApiGetActivePairs({})

  const history = useHistory()
  const goTo = (location: string): void => {
    history.push(location)
  }

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'ID',
      width: 70,
      editable: true
    },
    {
      field: 'currencyPairName',
      headerName: 'Pair',
      width: 100,
      editable: false
    },
    {
      field: 'currencyExchangeCode',
      headerName: 'Exchange',
      width: 150,
      editable: false
    },
    {
      field: 'rateValidityPeriodInSeconds',
      headerName: 'Rate Validity In Seconds',
      width: 180,
      editable: false
    },
    {
      field: 'feeRate',
      headerName: 'Fee Rate',
      width: 150,
      editable: false
    },
    {
      field: 'slippage',
      headerName: 'Slippage',
      width: 150,
      editable: false
    },
    {
      field: 'activeFrom',
      headerName: 'Active From',
      width: 200,
      editable: false,
      renderCell: (params: GridRenderCellParams) => {
        return <span>{formatDateStringAsApiFormat(params.value)}</span>
      }
    }
  ]

  return (
    <>
      <Box sx={{ mb: 4, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Typography variant={'h4'}>Currency Exchange Pairs</Typography>
        <Button variant={'text'} type="button" onClick={() => { goTo('/app/finance-area') }}>
          <HomeIcon style={{ color: '#444' }} />
        </Button>
      </Box>
      <Paper>
        <Box sx={{ p: 4, mt: 3 }}>
          <Box sx={{ p: 4, mt: 3 }}>
            {getActivePairsApiResult.isLoading && <LoadingComponent />}
            {(getActivePairsApiResult.error != null) && <ErrorComponent message={RtkQueryHelper.mapResponseError(getActivePairsApiResult.error)} />}
            { getActivePairsApiResult.isSuccess && (
                  <DataGrid
                    rows={getActivePairsApiResult.data}
                    columns={columns}
                    autoHeight={true}
                    pageSize={10}
                    rowsPerPageOptions={[5]}
                    disableSelectionOnClick
                  />
            )}
          </Box>
        </Box>
      </Paper>
    </>
  )
}

export default CurrencyExchangePairsPage
